import { forwardRef } from 'react';

import { isNot } from '@zenbusiness/application-commons-utils/is';

import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material/styles';

export default function superstyled({
  tag = Box,
  name,
  slot,
  props: propsAdded = {},
  propsNeeded = [],
  styles = {}
}) {
  const Styled = styled(tag, {
    name,
    slot,
    shouldForwardProp: propsNeeded.length ? isNot(propsNeeded) : undefined
  })(styles);

  const SuperStyledComponent = (propsInput) => {
    let added = propsAdded;
    const theme = useTheme();
    if (typeof propsAdded === 'function') {
      added = propsAdded({ ...propsInput, theme });
    }
    return (<Styled {...added} {...propsInput} />);
  };
  SuperStyledComponent.displayName = `${name}${slot || ''}`;
  Object.defineProperty(SuperStyledComponent, 'name', { value: SuperStyledComponent.displayName });
  return SuperStyledComponent;
}

export function superstyledWithRef({
  tag = Box,
  name,
  slot,
  props: propsAdded = {},
  propsNeeded = [],
  styles = {}
}) {
  const Styled = styled(tag, {
    name,
    slot,
    shouldForwardProp: propsNeeded.length ? isNot(propsNeeded) : undefined
  })(styles);

  const SuperStyledComponent = forwardRef((propsInput, ref) => {
    let added = propsAdded;
    const theme = useTheme();
    if (typeof propsAdded === 'function') {
      added = propsAdded({ ...propsInput, theme });
    }
    return <Styled ref={ref} {...added} {...propsInput} />;
  });

  SuperStyledComponent.displayName = `${name}${slot || ''}`;
  Object.defineProperty(SuperStyledComponent, 'name', { value: SuperStyledComponent.displayName });

  return SuperStyledComponent;
}
